import { orchestrator } from 'satcheljs';
import { responseRetrieved } from 'owa-request-manager';
import {
    completedTaskItemsResponseReceived,
    activeTaskItemsResponseReceived,
} from '../orchestrators/reloadItems';
import {
    GET_RECENTLY_COMPLETED_TASKS_SERVICE_IDENTIFIER,
    GET_TASKS_IN_FOLDER_SERVICE_IDENTIFIER,
} from './constants';

export const taskResponseRecieved = orchestrator(responseRetrieved, actionMessage => {
    if (actionMessage.responseIdentifier === GET_RECENTLY_COMPLETED_TASKS_SERVICE_IDENTIFIER) {
        completedTaskItemsResponseReceived(actionMessage.response);
    } else if (actionMessage.responseIdentifier === GET_TASKS_IN_FOLDER_SERVICE_IDENTIFIER) {
        activeTaskItemsResponseReceived(actionMessage.response);
    }
});
